import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, SortEvent } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SubverticalService } from './subvertical.service';
import { SubverticalmodalComponent } from 'src/app/views/directives/subverticalmodal/subverticalmodal.component';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { GlobalMessage, Subverticals } from '../../utility/modals';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-subvertical',
  templateUrl: './subvertical.component.html',
  styleUrls: ['./subvertical.component.css']
})
export class SubverticalComponent implements OnInit {
  @ViewChild('dt') dt: any;
  tableData: any[] = [];
  selectedItem: MenuItem | null = null;
  commonScrollHeight = '';
  searchText: string;
  ref: DynamicDialogRef | undefined;
  first2: number = 0;
  rows2: number = 10;
  totalRecords: number = 0;
  options = [];
  paginatorArray = []
  visible: boolean = false;
  excel_paragraph = '';
  templatedownloadtext = '';
  currentPageIndex: number = 0;
  subverticallistarray: Array<Subverticals> = [];
  exceldownloadModal = false;
  downloadformate = false;
  position = 'top';
  rowsize: number = 10;
  tablecount: number = 0;
  public sortfield = 'name';
  cols = [];
  message: GlobalMessage = new GlobalMessage()
  _selectedColumns = [];
  constructor(public router: Router,private spinner:NgxSpinnerService, public dialogService: DialogService, public PagehelpmodalService: PagehelpmodalService,
    private subverticalservice: SubverticalService, public utilityservice: Utilityservice) {
    this.excel_paragraph = this.message.downloadexcel_text;
    this.templatedownloadtext = this.message.excelformate_text
  }

  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight()
    this.getConfiguration();
    this.getsubverticalList();
    this.dynamiccols();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  }
  dynamiccols() {
    this.cols = [
      { field: "subverticalid", header: this.subverticalLabelName + " Id", type: 'Number', sort: true, filter: true, width: '20px', isChecked: true, class: 'headerid' },
      { field: "name", header: this.verticalLabelName + " Name", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "subverticalname", header: this.subverticalLabelName + " Name", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdby", header: "Created By", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdon", header: "Created On", type: 'Date', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' }
    ]
    this._selectedColumns = this.cols;
  }

    customSort(event: SortEvent) {
      console.log(event, "sort event");
      event.data.sort((data1, data2) => {
        let value1 = data1[event.field];
        let value2 = data2[event.field];
        let result = 0;
  
        // Handle null values
        if (value1 == null && value2 == null) return 0; // Both are null
        if (value1 == null) return event.order === 1 ? 1 : -1; // value1 is null
        if (value2 == null) return event.order === 1 ? -1 : 1; // value2 is null
  
        // Determine result based on field type
        if (typeof value1 === 'string' && typeof value2 === 'string') {
          if (event.field === 'createdon') {
            // Parse date strings into Date objects
            const date1 = new Date(value1.split('-').reverse().join(',')); // Convert "DD-MMM-YYYY" to "YYYY,MMM,DD"
            const date2 = new Date(value2.split('-').reverse().join(','));
            result = date1.getTime() - date2.getTime(); // Compare timestamps
          } else {
            // Handle departmentname and other strings
            if (event.field === 'name' || event.field === 'subverticalname') {
              result = value1.trim().toLowerCase().localeCompare(value2.trim().toLowerCase());
            } else {
              result = value1.localeCompare(value2);
            }
          }
        } 
        else if (typeof value1 === 'number' && typeof value2 === 'number') {
          // Numeric comparison
          result = value1 - value2;
        } else {
          // Fallback for mixed types or unexpected cases
          result = value1.toString().localeCompare(value2.toString());
        }
  
        return event.order === 1 ? result : -result;  // Adjust for ascending/descending order
      });
    }

  getsubverticalList() {
    //this.spinner.show();
    const currentPageSize = this.rowsize;

    this.subverticalservice.getall_subvertical().subscribe({
      next: (data: any) => {
        //this.spinner.hide();
        this.tableData = data;
        this.subverticallistarray = data.map((item: any) => ({ ...item, isSelect: false }));

        this.options = this.utilityservice.getOptionDropdown(data.length);
        this.paginatorArray = this.options.map((e) => e.value);

        if (!this.paginatorArray.includes(currentPageSize)) {
          this.paginatorArray.push(currentPageSize);
          this.paginatorArray.sort((a, b) => a - b);
        }

        this.rowsize = currentPageSize;
        this.totalRecords = this.subverticallistarray.length;
        this.tablecount = data.count ?? data.length;

        setTimeout(() => {
          if (this.dt) {
            this.dt.first = this.currentPageIndex;
          }
        }, 0);
      },
      error: (error) => {
        //this.spinner.hide();
        const timestamp = new Date().toLocaleString();
        Swal.fire({
          title: error.error?.error || "Error",
          text: `This error occurred at: ${timestamp}`,
          icon: "error",
        });
      },
    });
  }

  show(title, data) {
    let details = {}
    if (title === 'Modify Subvertical') {
      this.subverticalservice.get_subvertical_view(data.subverticalid).subscribe(res => {
        details = res;
        this.ref = this.dialogService.open(SubverticalmodalComponent, {
          header: "Modify "+this.subverticalLabelName,
          width: '50vw',
          height: 'auto',
          data: { title: title, datas: details,verticallabel:this.verticalLabelName,subverticallabel:this.subverticalLabelName},
          contentStyle: {},
          baseZIndex: 10000,
          maximizable: true,
        });
        this.ref.onClose.subscribe(() => {
          this.getsubverticalList();
        });
      })
    } else {
      details = {};
      this.ref = this.dialogService.open(SubverticalmodalComponent, {
        header: "Add "+this.subverticalLabelName,
        width: '50vw',
        height: 'auto',
        data: { title: title, datas: details,verticallabel:this.verticalLabelName,subverticallabel:this.subverticalLabelName},
        contentStyle: { overflow: '' },
        baseZIndex: 10000,
        maximizable: true,
      });
      this.ref.onClose.subscribe(() => {
        this.getsubverticalList();
      });
    }
  }

  //Download Department Master Excel
  downloadgridexcel() {
    this.subverticalservice.subverticalDataExcel().subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Subvertical_Master_Data.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.exceldownloadModal = false;
    }, error => {
      Swal.fire('Something went wrong', '', 'error');

    })
      ;
  }

  verticalLabelName = "";
  isSupportAdmin = "N";
  subverticalLabelName = "";
  getConfiguration(): void {
    this.subverticalservice.getConfiguration().subscribe(
      (response) => {
        if (response && response.length > 0) {
          this.verticalLabelName = response[0]?.verticalLabelName || 'Vertical Name';
          this.isSupportAdmin = response[0]?.isSupportAdmin || 'N';
          this.subverticalLabelName = response[0]?.subverticalLabelName || ' Sub Vertical Name';
          this.dynamiccols();
        }
      },
      (error) => {
        console.error('Error fetching configuration:', error);
        this.verticalLabelName = 'Vertical Name';
        this.dynamiccols();
      }
    );
  }

  subverticalDataExcel() {
    this.spinner.show();
    this.subverticalservice.subverticalDataExcel().subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = this.subverticalLabelName+'_Master_Data.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.exceldownloadModal = false;
      this.spinner.hide();
      Swal.fire('File downloaded successfully!', '', 'success');
    }, error => {
      this.spinner.hide();
      Swal.fire('Something went wrong', '', 'error');
    });
  }

  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }

}



